<script lang="ts" setup>
import GenericModal from '@shared/ui/components/modals/GenericModal.vue';
import LoginModalForm from '@features/auth/components/LoginModalForm.vue';
import RecoveryModalForm from '@features/auth/components/RecoveryModalForm.vue';
import { computed } from 'vue';
import { ref } from 'vue';

const currentView = ref<'login' | 'register' | 'recovery'>('login');

interface Props {
  modelValue: boolean;
  message?: string;
}

const props = withDefaults(defineProps<Partial<Props>>(), {});

const emit = defineEmits<{
  'update:modelValue': [value: boolean];
  'on:close': [];
}>();

const show = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit('update:modelValue', value);
  },
});

function handleViewChange(view: 'login' | 'register' | 'recovery') {
  currentView.value = view;
}

const modalTitle = computed(() => {
  switch (currentView.value) {
    case 'recovery':
      return 'Password recovery';
    default:
      return '';
  }
});
</script>

<template>
  <GenericModal
    v-model="show"
    :title="modalTitle"
    size="md"
    @on:close="emit('on:close')"
  >
    <template #default>
      <div data-testid="login-modal" class="px-6">
        <template v-if="currentView === 'login'">
          <p class="mb-4 text-center text-lg">
            {{ message }}
          </p>
          <LoginModalForm
            @change:view="handleViewChange"
            @close:modal="show = false"
          />
        </template>
        <template v-if="currentView === 'recovery'">
          <RecoveryModalForm @change:view="handleViewChange" />
        </template>
      </div>
    </template>
  </GenericModal>
</template>
